//PrimeReact
import { InputNumber } from "primereact/inputnumber"
import { Skeleton } from "primereact/skeleton"
import { Slider } from "primereact/slider"

//Formik
import { useField } from "formik"

//Style
import styles from "../../styles/Form-Inputs.module.css"

export default function FormikNumberInput({
  name,
  label,
  options,
  helpText,
  placeHolderValue,
  disabled,
  required,
  isInitialLoad,
  minFractionDigits,
  minValue,
  maxValue,
  currencyCode,
  showButtons,
  useSlider,
  inputTooltip,
  disableFormikSubmit, //Does not submit changes to formik. Can be used in conjunction with onChangeCallBack for manual processing
  onChangeCallBack,
}) {
  const [field, meta, helpers] = useField(name)

  const getInput = () => {
    if (isInitialLoad) {
      return (
        <Skeleton
          className={meta.touched && meta.error ? "p-invalid block" : "block"}
          height="42px"
        />
      )
    } else {
      return (
        <>
          <InputNumber
            value={+field.value}
            name={name}
            disabled={disabled}
            placeholder={placeHolderValue}
            onChange={(e) => {
              let newValue = e.value

              if (minValue && e.value < minValue) {
                newValue = minValue
              } else if (maxValue && e.value > maxValue) {
                newValue = maxValue
              }

              if (!disableFormikSubmit) {
                helpers.setValue(newValue)
              }

              if (onChangeCallBack) {
                onChangeCallBack(newValue)
              }
            }}
            className={meta.touched && meta.error ? "p-invalid" : undefined}
            style={{ width: "100%" }}
            minFractionDigits={
              minFractionDigits !== undefined ? minFractionDigits : 2
            }
            min={minValue}
            max={maxValue}
            mode={!!currencyCode ? "currency" : "decimal"}
            currency={currencyCode || undefined}
            showButtons={showButtons}
            buttonLayout="horizontal"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
            tooltip={inputTooltip}
            tooltipOptions={{ position: "bottom" }}
          />
          {useSlider ? (
            <Slider
              value={field.value}
              name={name}
              disabled={disabled}
              onChange={(e) => {
                if (!disableFormikSubmit) {
                  helpers.setValue(e.value)
                }

                if (onChangeCallBack) {
                  onChangeCallBack(e.value)
                }
              }}
              className={meta.touched && meta.error ? "p-invalid" : undefined}
              style={{ width: "100%" }}
              min={minValue}
              max={maxValue}
              tooltip={inputTooltip}
              tooltipOptions={{ position: "bottom" }}
            />
          ) : null}
          {meta.touched && meta.error ? (
            <label id={`${name}-error`} className={styles.errFieldMsg}>
              {meta.error}
            </label>
          ) : null}
        </>
      )
    }
  }

  const labelField = () => {
    if (isInitialLoad) {
      return <Skeleton width="10rem" height="1rem" />
    } else {
      return (
        <label>
          {label} {required ? <span style={{ color: "red" }}> * </span> : null}
        </label>
      )
    }
  }

  return (
    <div className={`${styles.field} fieldContainer`}>
      <label>{labelField()}</label>
      <div>
        {helpText ? (
          <div style={{ marginBottom: "10px" }}>
            <small style={{ color: "gray" }}>{helpText}</small>
          </div>
        ) : null}
        {getInput()}
      </div>
    </div>
  )
}
